/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Site } from './Site'
export type Event = {
  id?: number
  uuid?: string | null
  occured_at: string
  employee_id?: number | null
  task_id: number
  task_label?: string | null
  project_id?: number | null
  project_date_id?: number | null
  version_id?: number | null
  is_workplan_event?: boolean | null
  is_deleted?: boolean | null
  site?: Site | null
  time_recording_action?: Event.time_recording_action
}
export namespace Event {
  export enum time_recording_action {
    QR_CODE = 'qr code',
    NFC = 'nfc',
  }
}
